import React, { useMemo } from 'react'
import dayjs from 'dayjs'

import './style.scss'
import RegistrationHelper from 'general/helpers/RegistrationHelper'
import Utils, { getTaxCodeCompany } from 'general/utils/Utils'
import taxAuthorityMessageApi from 'api/taxAuthorityMessageApi'

function Message112(props) {
  const { message } = props
  console.log('message112', message)
  const isSent = useMemo(() => message.messageId?.startsWith('V'), [message])
  const TGHuy = useMemo(
    () => message.contentRaw?.TDiep?.DLieu?.TBHuy?.TGHuy,
    [message],
  )
  console.log('TGHuy', TGHuy)
  //   const So = useMemo(
  //     () => message.contentRaw?.TDiep?.DLieu?.TBao?.DLTBao?.So,
  //     [message],
  //   )
  const isReceived = false
  const TBHuy = useMemo(() => {
    let TBHuy = message.contentRaw?.TDiep?.DLieu?.TBHuy
    if (!TBHuy) return
    return Array.isArray(TBHuy) ? TBHuy : [TBHuy]
  }, [message])

  const viewPdfMessage112 = async () => {
    if (!message?.messageId) return
    let res = await taxAuthorityMessageApi.exportPdfMessage112(
      message.messageId,
    )
    let newFile = new File(
      [res],
      'Tờ khai đăng ký/thay đổi thông tin sử dụng hóa đơn.pdf',
      {
        type: 'application/pdf',
      },
    )
    var fileURL = URL.createObjectURL(newFile)
    window.open(fileURL, '_blank')
  }

  return (
    <div className="Message112 border-bottom mb-5">
      <div className="d-flex flex-row">
        <div style={{ maxWidth: '500px' }}>
          <p className="mb-2 ">
            <span
              style={{
                width: '18px',
                height: '18px',
                backgroundColor: isReceived ? '#00B416' : '#FF5563',
                textAlign: 'center',
                borderRadius: '100%',
                marginRight: '6px',
                display: 'inline-flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <i
                className={`fa-regular ${
                  isSent ? 'fa-arrow-up' : 'fa-arrow-down'
                }  text-white  `}
                style={{
                  fontSize: '12px',
                }}
              ></i>
            </span>

            <span className="text-time">
              {TGHuy && dayjs(TGHuy).format('DD/MM/YYYY hh:mm:ss')}
            </span>
          </p>

          <p className="mb-2">
            {`[${
              message.typeCode
            }] ${RegistrationHelper.renderRegistrationTypeCode(
              message.typeCode,
            )}`}
          </p>

          {TBHuy && (
            <div className="p-3" style={{ backgroundColor: '#fff3cd' }}>
              {TBHuy?.map(({ MLDo, LDHuy }, index) => (
                <p key={index} className="mb-2">
                  {`[${MLDo}] ${LDHuy}`}
                </p>
              ))}
            </div>
          )}

          {/* <p className="mb-2">
            Số thông báo:{' '}
            <a href="#" title="Xem thông báo">
              {So}
            </a>
          </p> */}

          <p className="mb-2" style={{ color: '#c4c4c4' }}>
            {`Mã thông điệp: ${message.messageId}`}
          </p>
        </div>
        <div className="text-right flex-fill">
          <p className="mb-2 font-weight-bold">
            {isSent
              ? getTaxCodeCompany(process.env.REACT_APP_SEARCH_PAGE_URL)
              : 'Cơ quan thuế'}
          </p>

          <p className="mb-2">
            <span
              style={{
                fontWeight: '500',
                borderRadius: '10px',
                fontSize: '13.2px',
                lineHeight: '16px',
                backgroundColor: isReceived ? '#E5F1E8' : '#FFEEEE', //#fff3cd
                color: isReceived ? '#20A144' : '#EE2334',
                padding: '4px 10px',
              }}
            >
              {isReceived ? 'CQT tiếp nhận' : 'CQT không tiếp nhận'}
            </span>
          </p>

          <div className="d-flex flex-row justify-content-end mb-2">
            {/* <p
              className="cursor-pointer mr-7"
              onClick={() => {
                viewPdfMessage112()
              }}
              title="Xem"
            >
              <i className="fa-regular fa-eye" style={{ color: 'inherit' }}></i>
            </p> */}
            <p
              className="cursor-pointer"
              onClick={() => {
                Utils.exportXmlFile({
                  data: message.contentRaw.TDiep,
                  fileName: 'thong-diep-112',
                })
              }}
              title="Xuất khẩu XML"
            >
              <i
                className="fa-regular fa-download"
                style={{ color: 'inherit' }}
              ></i>
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Message112
